import { createContext } from "react";
import { Route, Routes } from "react-router-dom";
import { VipHistoryList } from "../../modules/vipHistory/components/VipHistoryList";

const VipHistoryContext = createContext();

const VipHistoryWrapper = () => {
  const value = {};

  return (
    <VipHistoryContext.Provider value={value}>
      <Routes>
        <Route path="" element={<VipHistoryList />} />
      </Routes>
    </VipHistoryContext.Provider>
  );
};

export { VipHistoryWrapper };
